<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" granularity="day" @on-selected="onPanelSelect">
        <template slot="leftSide">
          <hierarchy-menu @on-selected="onSelectedDevice"></hierarchy-menu>
        </template>
      </graph-tool-bar>
      <br />
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.active_energy_import}}</h4>
        </md-card-header>
        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="pieChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import HierarchyMenu from "./components/HierarchyMenu";
import graphToolBar from "@/components/GraphToolBar";
import { loadData } from "./components/functions.js";

import snackBar from "@/components/SnackBar";
import pieChartOptions from "@/config/charts/pie";

export default {
  components: {
    HierarchyMenu,
    "snack-bar": snackBar,
    graphToolBar
  },

  data() {
    return {
      chartOptions: null,
      dateRange: {},
      devicesGroup: {},
    };
  },

  created() {
    this.chartOptions = JSON.parse(JSON.stringify(pieChartOptions));
    this.chartOptions.tooltip.pointFormat =
      "<b>{point.y:.1f} kWh</b> ({point.percentage:.1f}%)";
    this.chartOptions.plotOptions.pie.dataLabels.format =
      "<b>{point.name}</b>: {point.y:.1f} kWh ({point.percentage:.1f}%)";

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    async onPanelSelect(data) {
      this.dateRange = data.date;
      if (Object.keys(this.devicesGroup).length > 0) {
        this.$store.commit("setLoading", true);
        await loadData(this.devicesGroup, this.$refs.pieChart, this.dateRange, "E_I", this.$lang.charts.other);
        this.$store.commit("setLoading", false);
      }
    },

    async onSelectedDevice(devices) {
      this.devicesGroup = devices;
      if (Object.keys(this.dateRange).length > 0) {
        this.$store.commit("setLoading", true);
        await loadData(this.devicesGroup, this.$refs.pieChart, this.dateRange, "E_I", this.$lang.charts.other);
        this.$store.commit("setLoading", false);
      }
    }
  }
};
</script>

<style scoped>
</style>